<h1 class="text-2xl font-extrabold text-start ms-3">User Details</h1>
<div class="absolute right-0 top-0 pr-4 pt-4">
  <button mat-icon-button [matDialogClose]="undefined">
    <mat-icon
      class="text-secondary"
      [svgIcon]="'heroicons_outline:x-mark'"
    ></mat-icon>
  </button>
</div>
<div mat-dialog-content class="py-4 space-y-4 user-details-container p-3">
  <!-- Username -->
  <div class="flex items-center">
    <span class="font-bold">Username:</span>
    <span class="text-gray-700 ms-3">{{ user.username }}</span>
  </div>

  <!-- User Type -->
  <div class="flex items-center">
    <span class="font-bold">User Type:</span>
    <span class="text-gray-700 ms-3"
      >{{ user.userType | titlecase }} ({{user.userRoleType | titlecase
      }})</span
    >
  </div>

  <!-- Profile Information -->
  <mat-divider></mat-divider>
  <h2 class="text-lg font-semibold">Profile Information</h2>

  <!-- First Name -->
  <div class="flex items-center">
    <span class="font-bold">First Name:</span>
    <span class="text-gray-700 ms-3">{{ user.profile?.firstName }}</span>
  </div>

  <!-- Last Name -->
  <div class="flex items-center">
    <span class="font-bold">Last Name:</span>
    <span class="text-gray-700 ms-3">{{ user.profile?.lastName }}</span>
  </div>

  <!-- Email -->
  <div class="flex items-center">
    <span class="font-bold">Email:</span>
    <span class="text-gray-700 ms-3">{{ user.profile?.email }}</span>
  </div>

  <!-- Phone Number -->
  <div class="flex items-center"  *ngIf="!isIhcl" >
    <span class="font-bold">Mobile Number:</span>
    <span class="text-gray-700 ms-3">
      {{ user.profile?.contactInfo?.phone?.number }}</span
    >
  </div>

  <!-- Account Details -->
  <mat-divider></mat-divider>
  <h2 class="text-lg font-semibold">Account Details</h2>

  <!-- Last Login -->
  <div class="flex items-center">
    <span class="font-bold">Last Login:</span>
    <span class="text-gray-700 ms-3">{{
      user.lastLogin | date: "dd/MM/yyyy"
    }}</span>
  </div>

  <!-- Is Active -->
  <div class="flex items-center">
    <span class="font-bold">Is Active:</span>
    <mat-checkbox [checked]="user.status === 'active'" disabled></mat-checkbox>
  </div>
  <div *ngIf="user.status === 'new'">
    <button mat-stroked-button class="app-text" (click)="resendEmail()">
      Resend Email
    </button>
  </div>

  <!--- Vendor Name-->
  <ng-container *ngIf="user?.userType === 'vendor'">
    <mat-divider></mat-divider>
    <div class="flex items-center mt-4">
      <span class="font-bold">Vendor Name:</span>
      <span class="text-gray-700 ms-3">{{ user?.vendorName }}</span>
    </div>
  </ng-container>
</div>

<div mat-dialog-actions align="end" class="pt-4">
  <button
    mat-button
    mat-dialog-close
    mat-raised-button
    class="bg-primary-200 bg-white text-black"
    (click)="onCancelClick()"
  >
    Close
  </button>
  <!-- <button mat-raised-button class="app-button" (click)="editUser()">Edit User</button> -->
</div>
